import { createSelector } from '@reduxjs/toolkit';
import _ from 'lodash';
import { RootState } from '../store';

const selectInspections = (state: RootState) => state.inspections.inspections;

export const getInspectionByListingId = createSelector(
  [selectInspections],
  (inspections) => (listingId: string) =>
    inspections.find((inspection) => inspection.listingId === listingId)
);

// User-context-aware selector for all inspections by listingId and userId (works for all user types)
export const selectInspectionsByListingIdAndUserId = (
  listingId: string,
  userId: string
) =>
  createSelector([selectInspections], (inspections) =>
    inspections.filter(
      (inspection) =>
        inspection.listingId === listingId && inspection.userId === userId
    )
  );
